

import __layout_0 from '/home/runner/work/portal/portal/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/home/runner/work/portal/portal/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithVerticalNav': () => import('/home/runner/work/portal/portal/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/home/runner/work/portal/portal/src/layouts/components/Footer.vue'),
'components/NavBarNotifications': () => import('/home/runner/work/portal/portal/src/layouts/components/NavBarNotifications.vue'),
'components/NavbarShortcuts': () => import('/home/runner/work/portal/portal/src/layouts/components/NavbarShortcuts.vue'),
'components/NavbarThemeSwitcher': () => import('/home/runner/work/portal/portal/src/layouts/components/NavbarThemeSwitcher.vue'),
'components/UserProfile': () => import('/home/runner/work/portal/portal/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
